export default __webpack_public_path__ + "static/media/undraw_website-visitors_qy9c.1deecc5d.svg";